module.exports = __webpack_public_path__ + "img/arrow.b1ddd958.png";